module.exports = __webpack_public_path__ + "static/media/onoiwa-nav-l2.9b610fd4.png";